import { ModulesMappings } from "@/interfaces/enums";

import { isWeixin } from "@/utils/parserDevice";
import { i18n } from "next-i18next";
import { useEffect } from "react";

interface WXShareParams {
	title: string; // 分享标题
	imgUrl: string; // 分享图标
	desc: string; // 分享描述
}

export default function useWxShare(
	moduleKey?: ModulesMappings, // 活动分享用【拉新活动、返佣金、排行榜】
	inviteCode?: string,
	shareParams?: WXShareParams, // 其他非活动页分享的参数【hala、期权文章】
	nickname?: string,
) {
	const getShareParams = (moduleKey = "", inviteCode = "", nickname = "") => {
		return {
			title: i18Text(`${moduleKey}-title`, { inviteCode, nickname }),
			desc: i18Text(`${moduleKey}-description`, { inviteCode, nickname }),
			imgUrl: getImgUrl(moduleKey),
		};
	};
	const i18Text = (langKey: string, extend?: { [index: string]: string }) => {
		const isExist = i18n?.exists(`share:${langKey}`);
		if (isExist) {
			return i18n?.t(`share:${langKey}`, extend) || "";
		}
		return "";
	};
	const getImgUrl = (moduleKey: string) => {
		switch (moduleKey) {
			case ModulesMappings.ranking2022:
				return `${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/share/cup%402x.png`;
			default:
				return `${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/investing/logo-small.png`;
		}
	};

	const loadWxConfig = async () => {
		if (!isWeixin()) return;
		if (window.location.hostname.includes(".ai") || window.location.hostname.includes(".net")) return;
		try {
			const shareLink = window.location.href.split("#")[0];
			console.log(shareLink);
			const configResponse = await fetch(`/api/config/wechat?shareLink=${encodeURIComponent(shareLink)}`);
			const { appId, nonceStr, timestamp, signature } = await configResponse.json();

			const _shareParams = shareParams || getShareParams(moduleKey, inviteCode, nickname);

			window.wx.config({
				debug: false, // 关闭调试模式
				appId: appId, // 服务号的 appId
				timestamp: timestamp, // 服务端生成的时间戳
				nonceStr: nonceStr, // 服务端生成的随机串
				signature: signature, // 服务端生成的签名
				jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
			});

			window.wx.ready(function () {
				window.wx.updateAppMessageShareData({
					title: _shareParams.title,
					desc: _shareParams.desc, // 分享描述
					link: window.location.href, // 分享链接
					imgUrl: _shareParams.imgUrl, // 分享图标
					success: function () {
						console.log("分享配置成功");
					},
					fail: function (err: unknown) {
						console.error("分享配置失败", err);
					},
				});

				window.wx.updateTimelineShareData({
					title: _shareParams.title,
					link: window.location.href,
					imgUrl: _shareParams.imgUrl,
					success: function () {
						console.log("朋友圈分享配置成功");
					},
					fail: function (err: unknown) {
						console.error("朋友圈分享配置失败", err);
					},
				});
			});

			window.wx.error(function (err: unknown) {
				console.error("微信配置错误", err);
			});
		} catch (error) {
			console.error("加载微信配置失败", error);
		}
	};

	useEffect(() => {
		// 创建script标签
		const script = document.createElement("script");
		// 设置src属性
		script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
		// 设置async属性
		script.async = true;
		// script标签加载完成后调用
		script.onload = () => {
			loadWxConfig();
		};
		// script标签加载失败后调用
		script.onerror = (err) => {
			console.error("微信js加载失败", err);
		};
		// 将script标签添加到页面上
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);
}
